import React, { useContext } from "react";
import { MiscContext } from "components/MiscProvider";

export default function useMisc() {
  return useContext(MiscContext);
}
